// flow weak
import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
class AddTeam extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };
  constructor(props) {
    super(props);
    this.state = {
      game_types: [],
      team_details: {
        name: '',
        logo: '',
        game_type: '',
        jersey: ''
      },
      data_uploaded: false,
      data_error: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFileLogo = this.handleFileLogo.bind(this);
    this.handleFileJersey = this.handleFileJersey.bind(this);
  }
  componentDidMount() {
    this.getaddTeamInputs();
    console.log(this.state);
  }
  getaddTeamInputs() {
     const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_team/`;
     const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
         this.setState({game_types: data.game_types});
        })
       .catch(error => error);
  }
  postaddTeam(data, props) {
    if(!data.game_type){data.game_type=this.state.game_types[0].pk}
    console.log(data);
    const url = `${getLocationOrigin()}/eagleeye/add_team/`;
    const options = {...defaultOptions};
    var formData = new FormData();
    for(var name in data) {
      formData.append(name, data[name]);
    }
    options['method'] = 'post';
    options['body'] = formData;
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.message);
          props.history.goBack();
        })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }
  handleChange(event) {
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.team_details);
    new_selected_one[name] = event.target.value
    this.setState({team_details: new_selected_one});
  }
  handleSubmit(event) {
    event.preventDefault();
    this.postaddTeam(this.state.team_details, this.props);
    console.log('post');
    console.log(this.state);
  }
  handleFileLogo(selectorFiles          ){
    var new_selected_one =  Object.assign({}, this.state.team_details);
    console.log('Fileeeee');
    console.log(selectorFiles);
    new_selected_one['logo'] = selectorFiles[0]
    this.setState({team_details: new_selected_one});
  }
  handleFileJersey(selectorFiles          ){
    var new_selected_one =  Object.assign({}, this.state.team_details);
    console.log('Fileeeee');
    console.log(selectorFiles);
    new_selected_one['jersey'] = selectorFiles[0]
    this.setState({team_details: new_selected_one});
  }
  render() {
    return(
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Add New Team</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>
            <div className="col-md-12 alert alert-warning" style={{textAlign: 'center',
            fontSize: 'medium', color: 'black'}}>
              Please dont add an existing team!
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Team Name
              </div>
              <div className="col-md-6 input-group">
                <input type="text" style={styles.input} name="name" className="required"
                  value={this.state.value} onChange={this.handleChange}/>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game Type
              </div>
              <select name="game_type" className="col-md-6" style={styles.item_body} value={this.state.value}
                onChange={this.handleChange}>
                {
                  this.state.game_types.map((x, index) => (
                  <option key={x.pk} value={x.pk}>{x.game + " : " + x.name}</option>
                  ))
                }
              </select>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Logo
              </div>
              <input type="file" style={styles.input} name="logo" onChange={ (e) => this.handleFileLogo(e.target.files) }/>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Jersey
              </div>
              <input type="file" style={styles.input} name="jersey" onChange={ (e) => this.handleFileJersey(e.target.files) }/>
            </div>
            <div style={styles.button_submit} className="col-md-12">
              <input className="btn btn-lg" type="submit" value="Submit" style={{backgroundColor:'#302C35',
                color:'#ffffff'}}/>
            </div>
            <div className="col-md-12">
              {this.state.data_uploaded?<div className="text-success" style={styles.success}>* Fixture created successfully.</div>:''}
              {this.state.data_error?<div className="text-danger" style={styles.success}>* Error, creation failed.</div>:''}
            </div>
          </form>
        </div>
      </div>
    );
  }
}
export default AddTeam;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addTeam/index.js